// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"9fdfa8f6","465":"d7314c7c","814":"17cf64e1"}[chunkId] + ".chunk.css";
};